var map = {
	"./IMG_1.png": 67168,
	"./IMG_2.png": 45499,
	"./IMG_3_1_OVER.png": 67373,
	"./IMG_3_2_OVER.png": 38500,
	"./IMG_3_3_OVER.png": 72719,
	"./IMG_4.png": 35533,
	"./IMG_6.png": 18495,
	"./IMG_7.png": 21558,
	"./IMG_9.png": 88648,
	"./IMG_ABRE.png": 14239,
	"./IMG_NEXT.png": 55678
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 95694;